import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import swal from 'sweetalert';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';
import { updateProfile } from './actions';

class YourProfile extends React.Component {
    constructor() {
        super();
        this.state = {
            user: {},
            oldPassword: '',
            newPassword: '',
            repeatNewPassword: '',
            loading: false,
        };
        this.changeValue = this.changeValue.bind(this);
        this.updateProfile = this.updateProfile.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    componentWillMount() {
        const { loggedInUser } = this.props.user;
        this.setState({ user: loggedInUser });
    }

    async changePassword() {
        if (this.state.loading) return;
        const validPassword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[.$@$!%*#?&])[A-Za-z\d.$@$!%*#?&]{8,}$/.exec(this.state.newPassword);
        if (!validPassword) {
            swal({
                text: 'Password must have at least 8 chracters including at least one letter, one number and one special character',
                title: 'Change Password',
            });
            return;
        }
        if (this.state.newPassword !== this.state.repeatNewPassword) {
            swal({
                text: 'New password and Repeat New Password are not equal, please check again.',
                title: 'Change Password',
            });
            return;
        }
        const {
            user, oldPassword, newPassword, repeatNewPassword,
        } = this.state;
        const formValue = {
            oldPassword,
            newPassword,
            repeatNewPassword,
            id: user.Id,
        };
        this.setState({ loading: true });
        try {
            const result = await fetch(`${spmfcloudFunctionUrl}/auth/change-password`, {
                mode: 'cors',
                cache: 'no-cache',
                method: 'POST',
                body: JSON.stringify(formValue),
                headers: {
                    'hash-token': this.props.user.siteToken.hash,
                    'Content-Type': 'application/json',
                },
            }).then(async (response) => {
                if (response.status !== 200) {
                    const json = await response.json();
                    throw (new Error(json.message));
                }
                return response.json();
            });
            this.setState({
                loading: false, newPassword: '', oldPassword: '', repeatNewPassword: '',
            });
            swal({
                text: result.message,
                title: 'Success',
            });
        } catch (error) {
            swal({
                text: `${error}`,
                dangerMode: true,
                title: 'Error updating password',
            });
            this.setState({ loading: false });
        }
    }

    changeValue(attribute, value) {
        this.setState({
            user: {
                ...this.state.user,
                [attribute]: value,
            },
        });
    }

    async updateProfile() {
        if (this.state.loading) return;
        const { user } = this.state;
        try {
            const formValue = {
                Name: user.Name,
                HomePhone: user.HomePhone,
                MobilePhone: user.MobilePhone,
                Email: user.Email,
            };
            this.props.updateProfile(formValue);
            const result = await fetch(`${spmfcloudFunctionUrl}/auth/update-profile`, {
                mode: 'cors',
                cache: 'no-cache',
                method: 'PATCH',
                body: JSON.stringify(formValue),
                headers: {
                    'hash-token': this.props.user.siteToken.hash,
                    'Content-Type': 'application/json',
                },
            }).then(async (response) => {
                const json = await response.json();
                if (!response.ok) {
                    throw new Error(json.message);
                }
                return json;
            });
            this.setState({ loading: false });
            swal({
                text: result.message,
                title: 'Success',
            });
        } catch (error) {
            swal({
                text: `${error}`,
                dangerMode: true,
                title: 'Error',
            });
            this.setState({ loading: false });
        }
    }

    render() {
        const { user } = this.state;

        return (
            <div className="row">
                <div className="card list">
                    <p style={{ textAlign: 'center' }}>
                        {this.state.loading ? <i className="fa fa-5x fa-spinner fa-spin" /> : null}
                    </p>
                    <div className="row">

                        <div className="clearfix" />
                        <h4>Basic Info</h4>
                        <hr />
                        <div className="col-lg-6 col-sm-6 col-xs-12 col-md-6">
                            <div className="form-group">
                                <label>Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={user.Name}
                                    onChange={e => this.changeValue('Name', e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={user.Email}
                                    onChange={e => this.changeValue('Email', e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Agency/School</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={user.Account ? user.Account.Name : ''}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 col-xs-12 col-md-6">
                            <div className="form-group">
                                <label>Home Phone</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={user.HomePhone}
                                    onChange={e => this.changeValue('HomePhone', e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Mobile Phone</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={user.MobilePhone}
                                    onChange={e => this.changeValue('MobilePhone', e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Authority</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={user.Partner_Authority__c}
                                    disabled
                                />
                            </div>
                        </div>
                        <div className="clearfix" />
                        <div className="col-lg-12 col-xs-12 text-center" style={{ marginTop: 30 }}>
                            <button className="btn btn-primary btn-fill" onClick={this.updateProfile}>
                                <i className="fa fa-file" /> Update Profile
                            </button>
                        </div>
                    </div>

                    <h4>Password Changes</h4>
                    <p>This section is used to change your password to login to this partner portal.</p>
                    <hr />
                    <div className="row">
                        <div className="col-lg-6 col-md-8 col-sm-9 col-xs-12">
                            <div className="form-group">
                                <label>Old Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={this.state.oldPassword}
                                    onChange={e => this.setState({ oldPassword: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label>New Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={this.state.newPassword}
                                    onChange={e => this.setState({ newPassword: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label>Repeat New Password</label>
                                <input
                                    type="password"
                                    className="form-control"
                                    value={this.state.repeatNewPassword}
                                    onChange={e => this.setState({ repeatNewPassword: e.target.value })}
                                />
                            </div>
                            <div className="col-lg-12 col-xs-12 text-center" style={{ marginTop: 30 }}>
                                <button className="btn btn-primary btn-fill" onClick={this.changePassword}>
                                    <i className="fa fa-file" /> Update Password
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

YourProfile.propTypes = {
    user: PropTypes.object.isRequired,
    updateProfile: PropTypes.func.isRequired,
};

YourProfile.defaultProps = {

};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
        updateProfile,
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
});
export default connect(mapStateToProps, mapDispatchToProps)(YourProfile);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/UserManagement/YourProfile.js
// module id = 999
// module chunks = 0